import { NavType } from '../types';

var getSecondaryNavLinks = function getSecondaryNavLinks(_ref) {
  var navType = _ref.navType,
      user = _ref.user,
      onClickSignUp = _ref.onClickSignUp,
      onClickSignOut = _ref.onClickSignOut,
      limitNavigation = _ref.limitNavigation;
  var secondaryNavLinks = [];

  if (user) {
    secondaryNavLinks.push({
      text: navType === NavType.uversity ? 'Change password' : 'My account',
      href: 'my/account',
      loggingKey: 'my-account'
    });
  } // TODO: https://chegg.atlassian.net/browse/CUI-504


  if (navType === NavType.books) {
    secondaryNavLinks.push({
      text: 'My orders',
      href: 'my/orders',
      loggingKey: 'my-orders'
    }, {
      text: 'Track books',
      href: 'tracking',
      loggingKey: 'tracking'
    });
  }

  if (!limitNavigation) {
    secondaryNavLinks.push({
      text: 'Return books',
      href: 'returnbooks',
      loggingKey: 'return-books'
    }, {
      text: 'Sell books',
      href: 'sell-textbooks',
      loggingKey: 'sell-books'
    });
  }

  secondaryNavLinks.push({
    text: 'Help',
    href: navType === NavType.uversity ? 'contactus/2236039941' : 'contactus',
    loggingKey: 'help'
  });

  if (user) {
    secondaryNavLinks.push({
      text: 'Sign out',
      href: "signout?onlyView=1",
      loggingKey: 'signout',
      onClick: onClickSignOut
    });
  } else {
    secondaryNavLinks.push({
      text: 'Academic Integrity',
      href: 'about/academic-integrity',
      loggingKey: 'academic-integrity'
    }, {
      text: 'Create an account',
      href: 'signup',
      loggingKey: 'signup',
      shouldRedirectBack: true,
      onClick: onClickSignUp
    });
  }

  return secondaryNavLinks;
};

export default getSecondaryNavLinks;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/header/dist/esm/shared/getSecondaryNavLinks.js
// module id = 957
// module chunks = 11